import {builder}           from '@builder.io/react'
import merge               from 'lodash.merge'
import {pruneEmptyishHtml} from "./string"

const cachebustBuilderIo = true

builder.init('7123c8cb7bbb4e46b0238ef66de504d6')


/**
 * Fetch content from Builder.io with optional fallback + merging
 *
 * @param {Function} [opts.replaceVariableCallback] - Function to replace variables in the format [content, key, value, variableName]
 * @returns {Object|null} - Merged Builder data or null
 * @param {string} opts.model - The Builder model to query (e.g. 'category-landing-page')
 * @param {Object} opts.primaryQuery - Primary query for Builder (e.g. { name: `category-page-${category.token}` })
 * @param {Object} [opts.fallbackQuery] - Fallback query if the primary query fails (e.g. { name: 'category-page-default' })
 *
 * @returns {Object|null} - Merged Builder data or null
 */
const fetchBuilderContent = async (model, primaryQuery, fallbackQuery, replaceVariableCallback) => {
	console.log({model, primaryQuery, fallbackQuery})
	const replaceVariables = (content) => {
		if (!content || typeof content !== 'object') return content
		for (const key in content) {
			if (typeof content[key] === 'string') {
				content[key] = content[key].replace(/\[([^\]]+)\]/g, (_, variableName) => {
					const replacement = replaceVariableCallback?.(content, key, content[key], variableName)
					console.log(`callback replace parameter ${variableName} with value ${replacement} [${typeof(replaceVariableCallback)}]`)
					return replacement == null ? "" : replacement
				})
			} else if (typeof content[key] === 'object') {
				replaceVariables(content[key])
			}
		}
	}

	/*
	const [primaryData, fallbackData] = await Promise.all([
		builder.get(model, {
			query: { name: primaryQuery },
			cachebust: cachebustBuilderIo
		}),
		builder.get(model, {
			query: { name: fallbackQuery },
			cachebust: cachebustBuilderIo,
			userAttributes: { urlPath: '/', device: 'desktop', host: 'default' }, // neutral values
			includeUnpublished: false,
		}),
	])
	*/

	const results = await builder.getAll(model, {
		limit: 2,
		query: {
			'name': { $in: [primaryQuery, fallbackQuery] }
		},
		cachebust: cachebustBuilderIo===true
	})

	const primaryData = results[1]
	const fallbackData = results[0]

	let content
	if (primaryData) {
		primaryData.data = pruneEmptyishHtml(primaryData?.data)
		primaryData.data = pruneEmptyishHtml(primaryData?.data)
		content = merge({}, fallbackData?.data || {}, primaryData?.data || {})
		if (replaceVariableCallback) replaceVariables(content)
	}
	else {
		content = fallbackData?.data || null
		if (replaceVariableCallback) replaceVariables(content)
	}

	return content
}

async function fetchPageContent(path) {
	return await builder
		.get('content-page', {
			query: {
				name: `page-${path}`,
			},
			cachebust: cachebustBuilderIo===true,
		})
		.toPromise()
}


export default builder

export {
	fetchBuilderContent,
	fetchPageContent
}
